import { render, staticRenderFns } from "./materials-drag.vue?vue&type=template&id=522d913d&scoped=true&"
import script from "./materials-drag.vue?vue&type=script&lang=js&"
export * from "./materials-drag.vue?vue&type=script&lang=js&"
import style0 from "./materials-drag.vue?vue&type=style&index=0&id=522d913d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522d913d",
  null
  
)

export default component.exports